// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FeaturedCmp$PorterinFeature from "./FeaturedCmp.mjs";
import * as DownloadHelpers$PorterinFeature from "../../../../shared/download-app/helpers/DownloadHelpers.mjs";
import * as CustomerReviewsCmp$PorterinFeature from "./CustomerReviewsCmp.mjs";
import * as MiddleSectionModuleScss from "../styles/MiddleSection.module.scss";
import * as PorterFootprintsCmp$PorterinFeature from "./PorterFootprintsCmp.mjs";
import * as StickyVisibilityContext$PorterinFeature from "../../../../contexts/sticky-visibilty-context/StickyVisibilityContext.mjs";

var styles = MiddleSectionModuleScss;

function MiddleSectionCmp(Props) {
  var data = Props.data;
  var match = StickyVisibilityContext$PorterinFeature.useStickyVisibilityContext(undefined);
  var setIsStickyHidden = match.setIsStickyHidden;
  var containerRef = React.useRef(null);
  var icons = data.icons;
  var wave_icon = icons.wave_icon;
  React.useEffect((function () {
          return DownloadHelpers$PorterinFeature.hideStickyBasedOnScroll("0px 0px", 0.15, containerRef, true, setIsStickyHidden);
        }), []);
  return React.createElement("div", {
              ref: containerRef,
              className: styles.container
            }, React.createElement(PorterFootprintsCmp$PorterinFeature.make, {
                  porter_footprints_data: data.porter_footprints
                }), React.createElement(CustomerReviewsCmp$PorterinFeature.make, {
                  testimonials_data: data.testimonials,
                  wave_icon: wave_icon,
                  star_icon: icons.star_icon
                }), React.createElement(FeaturedCmp$PorterinFeature.make, {
                  news_articles_data: data.in_the_news,
                  redirect_icon: icons.redirect_icon,
                  wave_icon: wave_icon,
                  read_article_label: data.read_article_label,
                  title: data.in_the_news_title
                }), React.createElement("div", {
                  className: styles["blue-gradient"]
                }), React.createElement("div", {
                  className: styles["gold-gradient-1"]
                }));
}

var make = MiddleSectionCmp;

var $$default = MiddleSectionCmp;

export {
  styles ,
  make ,
  $$default ,
  $$default as default,
}
/* styles Not a pure module */
